<template>
	<div class="roleManage">
		<div class="search">
			<span class="title">角色管理</span>
			<div class="flex">
				<el-input placeholder="请输入关键词搜索" suffix-icon="el-icon-search" v-model="key"></el-input>
				<el-button type="success" @click="getList">搜 索</el-button>
				<el-button type="success" @click="openDialog">新增</el-button>
			</div>
		</div>
		<div class="table">
			<el-table :data="tableData"  v-loading="loading" element-loading-text="数据加载中..." height="700px" align="center" :header-cell-style="{background:'#f4f7fe'}">
				<el-table-column prop="roleName" label="角色名称" width="150"></el-table-column>
				<el-table-column prop="rolePowerName" label="权限"></el-table-column>
				<el-table-column prop="creationTime" label="创建时间" width="200"></el-table-column>
				<el-table-column label="操作" width="200" align="right">
					<template slot-scope="scope">
						<el-button @click="setting(scope.row)" type="success" size="small">设置</el-button>
						<el-button @click="deleteRowData(scope.row)" type="success" size="small">删除</el-button>
					</template>
				</el-table-column>
			</el-table>
		</div>
		<div class="page">
			<el-pagination
				@size-change="handleSizeChange"
				@current-change="handleCurrentChange"
				:current-page.sync="currentPage"
				:page-sizes="[10, 20, 50]"
				layout="sizes, prev, pager, next"
				:total="total"
			></el-pagination>
		</div>
		<!-- 详情对话框 -->
		<el-drawer title="用户详情" :visible.sync="detailModal" append-to-body>
			<el-form :model="detailForm" ref="detailForm" style="padding:10px">
				<el-form-item label="用户名" laber-width="120px">
					<span>{{ detailForm.UserName }}</span>
				</el-form-item>
				<el-form-item label="用户类型" laber-width="120px">
					<span>
						{{
							detailForm.UserType == 0
								? '普通用户'
								: detailForm.UserType == 1
								? '集材点'
								: detailForm.UserType == 2
								? '加工厂'
								: detailForm.UserType == 3
								? '设计公司'
								: detailForm.UserType == 4
								? '监管单位'
								: detailForm.UserType == 5
								? '其他部门'
								: '单位人员'
						}}
					</span>
				</el-form-item>
				<el-form-item label="电话号码" laber-width="120px">
					<span>{{ detailForm.Phone }}</span>
				</el-form-item>
				<el-form-item label="地址" laber-width="120px">
					<span>{{ detailForm.Address }}</span>
				</el-form-item>
				<el-form-item label="是否实名" laber-width="120px">
					<el-tag type="danger" v-if="detailForm.IsRealName">已实名</el-tag>
					<el-tag type="success" v-else>未实名</el-tag>
				</el-form-item>
				<el-form-item label="登录次数" laber-width="120px">
					<span>{{ detailForm.loginNum }}</span>
				</el-form-item>
				<el-form-item label="身份证前照片" laber-width="120px">
					<!-- <div v-if="detailForm.IDCardImageTops">
						<img
							v-if="detailForm.IDCardImageTops.SmallPath"
							:src="detailForm.IDCardImageTops.SmallPath"
							class="avatar"
						/>
					</div> -->
					<showImages :imgs="detailForm.IDCardTops"></showImages>
				</el-form-item>
				<el-form-item label="身份证后照片" laber-width="120px">
					<showImages :imgs="detailForm.IDCardAfters"></showImages>
					<!-- <div v-if="detailForm.IDCardImageAfters">
						<img
							v-if="detailForm.IDCardImageAfters.SmallPath"
							:src="detailForm.IDCardImageAfters.SmallPath"
							class="avatar"
						/>
					</div> -->
				</el-form-item>
				<el-form-item label="企业资质证明照片" laber-width="120px">
					<!-- <div style="display: flex;align-items: center;">
						<div v-for="(item, index) in detailForm.QualificationsImagess" class="endImage" :key="index">
							<img :src="item.SmallPath" class="avatar" />
						</div>
					</div> -->
					<showImages :imgs="detailForm.Qualifications"></showImages>
				</el-form-item>
			</el-form>
		</el-drawer>
		<!-- 设置权限 -->
		<Dialog
			:isDialogVisible="dialogVisible"
			:authority="authority"
			:allAuthority="allAuthority"
			:authorityName="authorityName"
			:id="id"
			:dialogType="dialogType"
			@close-dialog="dialogVisible = $event"
			@dialog-confirm="handleEditConfirm"
		/>
	</div>
</template>

<script>
import { GetRoleList,GetRolePowers,Delete } from '@/api/Role.js';
import { getUserDetail } from '../../api/user.js';
import Dialog from './components/roleAction.vue';
import showImages from '@/components/showImage'
export default {
	name: 'roleManage',
	components: {
		Dialog,
		showImages
	},
	data() {
		return {
			detailModal: false, //详情
			key: '', // 搜索关键字
			loading: false, // 数据是否处于加载状态
			tableData: [], // 表格数据
			detailForm: {}, //详情数据
			total: 0, // 数据总数
			currentPage: 1, // 当前页数
			pageSize: 10, // 当前查询数据个数
			dialogVisible: false, // 对话框是否显示
			authority: [], //当前数据所有权限
			allAuthority: [],
			authorityName: '', //当前的权限名称
			id: 0, //当前编辑id
			dialogType: 'add', //弹窗类型
			rightDrawerShow: false, //右侧

		};
	},
	computed: {
		user() {
			return this.$store.state.user;
		}
	},
	mounted() {
		this.getList();
		this.getAllAuthority();
	},
	methods: {
		// 分页查询
		handleSizeChange(e) {
			this.pageSize = e;
			this.getList();
		},
		handleCurrentChange(e) {
			this.currentPage = e;
			this.getList();
		},
		/*获取所有数据列表 */
		async getList() {
			this.loading = true
			try {
				let params = {
					pageNumber: this.currentPage,
					pageSize: this.pageSize,
					keyword:this.key
				};
				let { data } = await GetRoleList(params);
				if (data.state === 1) {
					
					this.tableData = data.data.lis;
					this.total = data.data.count;
					this.loading = false
				} else {
					this.loading = false
					this.$message.error(data.message);
				}
			} catch (err) {
			}
		},
		handleEditConfirm() {
			this.dialogVisible = false;
			this.getList();
		},
		// 获取所有权限列表
		getAllAuthority() {
			GetRolePowers().then(res => {
				if (res.data.state == 1) {
					let data = res.data.data;
					data.forEach(item=>{
						this.allAuthority.push({ key: item.rolePower, label: item.rolePowerName });
					})
				}
			});
		},
		// 打开设置
		setting(row) {
			this.authority = row.rolePower ? JSON.parse(row.rolePower) : [];
			this.authorityName = row.roleName;
			this.id = row.id;
			this.dialogType = 'edit';
			this.dialogVisible = true;
		},
		/* 详情 */
		lookDetail(row) {
			getUserDetail({ getUserCode: row.UserCode }).then(res => {
				if (res.data.state == 1) {
					this.detailForm = JSON.parse(res.data.data);
					if(this.detailForm.IDCardImageTops){
						let arr  = []
						arr.push(this.$store.state.imgUrl + this.detailForm.IDCardImageTops.Id)
						this.detailForm.IDCardTops = arr
					}
					if(this.detailForm.IDCardImageAfters){
						let arr2 = []
						arr2.push(this.$store.state.imgUrl + this.detailForm.IDCardImageAfters.Id)
						this.detailForm.IDCardAfters = arr2
					}
					if(this.detailForm.QualificationsImagess.length > 0){
						let arr3 = []
						this.detailForm.QualificationsImagess.forEach(item => {
							arr3.push(this.$store.state.imgUrl + item.Id)
						});
						this.detailForm.Qualifications = arr3
					}
					// if (this.detailForm.IDCardImageTops.SmallPath) {
					// 	this.detailForm.IDCardImageTops.SmallPath =
					// 	this.$store.state.imgUrl + this.detailForm.IDCardImageTops.Id;
					// }
					// if (this.detailForm.IDCardImageAfters.SmallPath) {
					// 	this.detailForm.IDCardImageAfters.SmallPath =
					// 	this.$store.state.imgUrl + this.detailForm.IDCardImageAfters.Id;
					// }
					// if (this.detailForm.QualificationsImagess.length > 0) {
					// 	this.detailForm.QualificationsImagess.forEach(item => {
					// 		item.SmallPath = this.$store.state.imgUrl + item.Id;
					// 	});
					// }
				}
			});
			this.detailModal = true;
		},
		/* 通过ID删除单行数据 */
		deleteRowData(row) {
			this.$confirm('确定删除？', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			})
				.then(() => {
					Delete(row.id).then(res => {
						if (res.data.state == 1) {
							this.$message.success('操作成功');
							this.getList();
						} else {
							this.$message.erroe(res.data.Msg);
						}
					});
				})
				.catch(() => {});
		},
		// 打开添加弹窗
		openDialog() {
			this.dialogVisible = true;
			this.authority = [];
			this.authorityName = '';
			this.dialogType = 'add';
		}
	}
};
</script>
<style lang="less" scoped>
.roleManage {
	height: 100%;
	width: 100%;
	position: relative;
	.search {
		padding: 15px;
		display: flex;
		align-items: center;
		justify-content: space-between;
		.el-input {
			margin-right: 20px;
			width: 300px;
		}
		.title {
			font-size: 20px;
			font-weight: bold;
		}
	}
	.table {
		padding: 0px 15px;
	}
	.page {
		text-align: center;
	}
	/deep/ .el-dialog__header {
		padding: 10px;
		background-color: #5bacf0;
	}
	/deep/ .el-dialog__title {
		color: #fff;
	}
	/deep/ .el-dialog__body {
		padding: 15px;
	}
	/deep/ .el-dialog__footer {
		padding: 0px 10px 10px 10px;
	}
}
.avatar {
	width: 100px;
	height: 100px;
	margin-right: 10px;
}
</style>
